import {
  RouteParams as UniversalRouteParams,
  RouterContext,
} from 'universal-router';

import { PortalConfig } from 'src/context';

export interface RouteAction {
  (ctx: RouteActionContext): RouteActionResult;
}

export interface RouteActionContext {
  isAssemblyDomain: boolean;
  params: UniversalRouteParams;
  portalConfig: PortalConfig;
  query?: {
    step?: string;
  };
}

/**
 * Type guard that checks if a RouterContext has all required properties to be used as RouteActionContext.
 * This enables type narrowing for safe conversion.
 *
 * @param context - The RouterContext to check
 * @returns true if context has all required properties for RouteActionContext
 */
export function isRouteActionContext(
  context: RouterContext,
): context is RouterContext & RouteActionContext {
  return context.portalConfig !== undefined && context.portalConfig !== null;
}

export interface RouteActionResult {
  chunks: string[];
  component: React.ReactNode;
  title?: string;
  browserTitle?: string;
  description?: string;
  socialShareImage?: string;
  prefetchUrls?: string[];
  shouldIgnoreSEOIndexing?: boolean;
  /** The client router builds RouteContext.params from this, not from the URL. */
  params?: UniversalRouteParams;
}
